var colse_icon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z"></path></svg>`;
var remove_icon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M7 4V2H17V4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z"></path></svg>`;
var share_icon = `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.07609 11.4364C8.07609 11.7015 8.29098 11.9164 8.55609 11.9164C8.82118 11.9164 9.03609 11.7015 9.03609 11.4364V2.72838L11.3789 5.07122C11.5664 5.25867 11.8703 5.25867 12.0578 5.07122C12.2452 4.88378 12.2452 4.57986 12.0578 4.3924L8.90175 1.23639C8.80918 1.14382 8.6882 1.09697 8.56689 1.09582C8.56329 1.09574 8.55969 1.0957 8.55609 1.0957C8.54902 1.0957 8.54198 1.09586 8.53498 1.09616C8.4061 1.09126 8.27561 1.138 8.17721 1.2364L5.02121 4.3924C4.83375 4.57986 4.83375 4.88377 5.02121 5.07123C5.20866 5.25869 5.51258 5.25869 5.70002 5.07123L8.07609 2.69517V11.4364Z" fill="currentColor"></path>
<path d="M2.7188 9.1465C2.7188 8.88142 2.50388 8.6665 2.2388 8.6665C1.97369 8.6665 1.75879 8.88142 1.75879 9.1465V12.8241C1.75879 13.9728 2.69004 14.9041 3.8388 14.9041H13.1609C14.3097 14.9041 15.2409 13.9728 15.2409 12.8241V9.1465C15.2409 8.88142 15.026 8.6665 14.7609 8.6665C14.4958 8.6665 14.2809 8.88142 14.2809 9.1465V12.8241C14.2809 13.4426 13.7795 13.9441 13.1609 13.9441H3.8388C3.22024 13.9441 2.7188 13.4426 2.7188 12.8241V9.1465Z" fill="currentColor"></path>
</svg>`;
$(document).ready(function(e) {
  const ADD = "ADD";
  const CHANGE = "CHANGE";
  const UPDATE = "UPDATE";
  const CART = "CART";
  const CART_HTML = "CART_HTML";
  const CART_DRAWER_HTML = "CART_DRAWER_HTML";

  const performServerAction = async function(data, action = ADD, from) {
    let url = "/cart/add.js";
    let method = action.includes("CART") ? "GET" : "POST";
  
    if (action === CHANGE) url = "/cart/change.js";
    if (action === UPDATE) url = "/cart/update.js";
    if (action === CART) url = "/cart.js";
    if (action === CART_HTML) url = "/cart";
    if (action === CART_DRAWER_HTML) url = window.location.pathname;
  
  
    if (action == ADD && from) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
      var body = data;
    } else {
      var headers = {
        "Content-Type": action.includes("HTML") ? "text/html" : "application/json",
        "X-Requested-With": "xmlhttprequest",
        "Cache-Control": "no-cache, no-store, must-revalidate",
        Pragma: "no-cache",
        Expires: 0
      }
      var body = data && JSON.stringify(data);
    }
  
    try {
      const response = await fetch(url, {
        method: method,
        credentials: "same-origin",
        headers: headers,
        body: body
      });
  
      const responseData = await (action.includes("HTML") ? response.text() : response.json());
      if (responseData.status) {
        throw new Error(responseData.description);
      }
  
      return responseData;
    } catch (error) {
      console.error(error);
    }
  };
  const checkCartItemProperties = async function() {
    try {
      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
  
      const cartData = await cartResponse.json();
      let greeting_card = false;
      cartData.items.forEach(function(item) {
        if (item.properties) {
          if (item.properties && item.properties['_Card Isle Print Code']) {
            greeting_card = true;
          }
        }
      });
      if(greeting_card){
        setTimeout(function() {
          document.querySelector('.cart-link').click();
           jQuery.getJSON('/cart.js', function(cart) {
            let cartData = cart.items;
            document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: cartData
            })); 
           });
         }, 400);
      }else{
         $('.greeting-card').addClass('show');
      }
    } catch (error) {
      console.error("Error checking cart item properties: ", error);
    }
  };
  var activeProducts = {
    items: []
  };
  function storeActiveProducts() {
    localStorage.setItem('activeProducts', JSON.stringify(activeProducts.items));
  }
  function loadActiveProducts() {
    var storedProducts = localStorage.getItem('activeProducts');
    if (storedProducts) {
      activeProducts.items = JSON.parse(storedProducts);
    }
  } 
  function getQuantity() {
    var totalQty = 0;
    $.each(activeProducts.items, function(index, product) {
      totalQty += product.quantity;
    });
    if (totalQty == 0 ) {
      $('.add_box_btn').addClass('disabled');
    } else {
      $('.add_box_btn').removeClass('disabled');
    }
  }
  function getSubtotal() {
    var total = parseInt($('.pro-summary-bottom .pro-price').attr('data-total-price'));
    $.each(activeProducts.items, function(index, product) {
      total += parseInt(product.price) * product.quantity; // Multiply price by quantity
    });
    $('.complete-btn span').text(Shopify.formatMoney(total));
    $('.pro-summary-bottom .pro-price').text(Shopify.formatMoney(total));
  }
  function getShareUrl() {
    var share_array = {
      items: []
    };
     activeProducts.items.forEach(function(product) {
     var productInfo = {
        id: product.p_id,
        producthandle: product.handle,
        selectCount: product.quantity,
        selected_variant_id: product.variantId
      };
      share_array.items.push(productInfo);
    });
    if (window.location.href.indexOf('?') > -1) {
      var linkUrl = window.location.href +'&products='+  encodeURIComponent(JSON.stringify(share_array.items));
    } else {
      var linkUrl = window.location.href +'?products='+  encodeURIComponent(JSON.stringify(share_array.items));
    }
    var $link = $("a.box-share-box").attr("href", linkUrl);
    $('body').on("click","a.box-share-box", function(e) {
      e.preventDefault();
      var _this = $(this);
      navigator.clipboard.writeText(linkUrl)
      .then(() => {
        if(_this.closest('.share-box-btn').length > 0) {
          _this.closest('.share-box-btn').find('a.box-share-box').text("Link copied");
        } else {
          _this.closest('.current-box-btns').find('a.box-share-box').text("Link copied to clipboard!");
        }
        setTimeout(function() { 
          $link.html("Share Box"+ share_icon);
        }, 2000);
      })
      .catch(err => {
        console.error("Failed to copy: ", err);
      });
    });
  }
  function getCheckProduct(product,qty,variantId){
    if (product) {
      product.quantity = qty;
      updateProductInUI(variantId, product);
      storeActiveProducts();
      getShareUrl();
      getQuantity();
      getSubtotal(); 
    }
  }
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  if(window.location.href.includes('products')) {
    var share_array = JSON.parse(getParameterByName('products'));
    share_array.forEach(function(product) {
      addProduct(product.producthandle,product.selectCount,product.selected_variant_id);
      $('.gift-more-product .gift-product-grid li').each(function(index, element) {
        if(product.selected_variant_id == parseInt($(element).attr('data-variant'))){
          if ($(element).find('.add-pro-qty-wpr').length > 0) {
            $(element).find('.add-pro-qty-wpr').find('input.pro-qty-input').val(product.selectCount);
            $(element).find('.add-pro-qty-wpr').find('.total-count').text(`${product.selectCount} IN BOX`);
            $(element).find('.add-pro-gift').hide();
            $(element).find('.add-pro-qty-wpr').show();
          } else {
            $(element).find('.add-pro-gift').hide();
          }
        }
      });
    });
    setTimeout(function() {
     window.history.replaceState(null, null, window.location.pathname + '?view=box-builder');
    },5000)
  } else {
    loadActiveProducts();
    activeProducts.items.forEach(function(product) {
      $('.gift-more-product .gift-product-grid li').each(function(index, element) {
        if (product.variantId == parseInt($(element).attr('data-variant'))) {
          if ($(element).find('.add-pro-qty-wpr').length > 0) {
            $(element).find('.add-pro-qty-wpr').find('input.pro-qty-input').val(product.quantity);
            $(element).find('.add-pro-qty-wpr').find('.total-count').text(`${product.quantity} IN BOX`);
            $(element).find('.add-pro-gift').hide();
            $(element).find('.add-pro-qty-wpr').show();
          } else {
            $(element).find('.add-pro-gift').show();
          }
        }
      });
      appendProductToUI(product.variantId, product);
    });
    getShareUrl();
    getQuantity();
    getSubtotal();
  }
  function addProduct(Handle,Qty,Id) {
    $.getJSON('/products/' + Handle+'.js', function(data) {
      var product = data;
      var variant = product.variants.find(function(v) {
        return v.id === Id;
      });
      var variant_title = '';
      product.variants.forEach(function(variant){
        if(variant.id == Id && variant.title != 'Default Title') {
          variant_title = variant.title
        }
      });
      var product_image = '';
      product.media.forEach(function(image) {
      if (product.variants[0].title != 'Default Title') {
        product.variants.forEach(function(variant) {
          if (variant.id == Id && variant.featured_media.id == image.id) {
            product_image = image.src;
          } 
        });
        } else {
          product_image = product.images[0]
        }
      });
      var variant_price = ''
      if (product.variants[0].title != 'Default Title') {
       product.variants.forEach(function(variant) {
          if (variant.id == Id) {
            variant_price = variant.price;
          }
        });
      } else {
       variant_price = product.price
      } 
      var productInfo = {
        variantId: variant.id,
        p_id: product.id,
        title: product.title,
        variant: variant_title,
        handle: product.handle,
        price: variant.price,
        imageSrc: product_image,
        quantity: Qty
      };
      activeProducts.items.push(productInfo);
      activeProducts.items.forEach(function(product) {
        $('.gift-more-product .gift-product-grid li').each(function(index, element) {
          if (product.variantId == parseInt($(element).attr('data-variant'))) {
            if ($(element).find('.add-pro-qty-wpr').length > 0) {
              $(element).find('.add-pro-qty-wpr').find('input.pro-qty-input').val(product.quantity);
              $(element).find('.add-pro-qty-wpr').find('.total-count').text(`${product.quantity} IN BOX`);
            }
          }
        });
      });
      appendProductToUI(variant.id, productInfo);
      getShareUrl();
      storeActiveProducts();
      getQuantity();
      getSubtotal(); 
    });
  }
  function updateProductInUI(variantId, productInfo) {
    var productUI = $('.pro-summary-middle .pro-info[data-id="' + variantId + '"]');
    if (productUI.length > 0) {
      var product_title = productInfo.title;
      var ProductTitle = product_title.length > 20 ? product_title.substring(0, 20) + '...' : product_title;
      productUI.find('.pro-name').html(ProductTitle + ' x ' + productInfo.quantity); // Update quantity
      var itemPrice = productInfo.price * productInfo.quantity;
      productUI.find('.pro-price').text(Shopify.formatMoney(itemPrice)); // Update price
    }
    var product_UI = $('.pro-list-ul li[data-id="' + variantId + '"]');
     if (product_UI.length > 0) {
       product_UI.find('.item-qty').html('<p>Qty:'+ productInfo.quantity +'</p>');
     }
  }
  function appendProductToUI(variantId, productInfo) {
    if ($('.gift-img-ul li[data-id="' + variantId + '"]').length === 0) {
        $('<li class="remove-items" data-id="' + variantId + '"></li>')
            .html('<img src="' + productInfo.imageSrc + '" /><div class="close-icons">' + colse_icon + '</div>')
            .appendTo('.gift-img-ul');
    }

    if ($('.pro-list-ul li[data-id="' + variantId + '"]').length === 0) {
        $('<li data-id="' + variantId + '" data-product-handle="'+ productInfo.handle + '" ></li>')
            .html('<div data-target-modal><img src="' + productInfo.imageSrc + '" /></div><div class="remove-items">' + colse_icon + '</div> <div class="item-qty"><p>Qty:'+ productInfo.quantity +'</p></div>')
            .appendTo('.pro-list-ul');
    }

    if ($('.pro-summary-middle .pro-info[data-id="' + variantId + '"]').length === 0) {
        var product_title = productInfo.title;
        var ProductTitle = product_title.length > 20 ? product_title.substring(0, 20) + '...' : product_title;
        if (productInfo.variant != 'undefined' && productInfo.variant != '') {
          $('<div class="pro-info text-right" data-id="' + variantId + '" data-price="' + productInfo.price + '"></div>')
            .html('<div class="pro-name">' + ProductTitle + '(' + productInfo.variant + ')' + ' x '+ productInfo.quantity +'</div><div class="pro-price">' + Shopify.formatMoney(productInfo.price) + '</div>')
            .appendTo('.pro-summary-middle');
        } else {
          $('<div class="pro-info text-right" data-id="' + variantId + '" data-price="' + productInfo.price + '"></div>')
            .html('<div class="pro-name">' + ProductTitle + ' x '+ productInfo.quantity +'</div><div class="pro-price">' + Shopify.formatMoney(productInfo.price) + '</div>')
            .appendTo('.pro-summary-middle');
        }
        
    }
  }
  function removeProduct(variantId) {
    activeProducts.items = activeProducts.items.filter(function(product) {
      return product.variantId !== variantId;
    });
    storeActiveProducts();
    getShareUrl();
    removeProductFromUI(variantId);
    getQuantity();
    getSubtotal();
  }
  function removeProductFromUI(variantId) {
    $('.gift-img-ul li[data-id="' + variantId + '"]').remove();
    $('.pro-list-ul li[data-id="' + variantId + '"]').remove();
    $('.pro-summary-middle .pro-info[data-id="' + variantId + '"]').remove();
    var productLi = $('.gift-product-grid li[data-variant="' + variantId + '"]');
    if (productLi.find('.add-pro-qty-wpr').length > 0) {
      productLi.find('.add-pro-qty-wpr').hide();
      productLi.find('.add-pro-gift').show();
      productLi.find('input.pro-qty-input').val(0);
      productLi.find('.add-pro-qty-wpr').find('.total-count').text(0 +' IN BOX');
    } else {
      productLi.find('.add-pro-gift').show();
    }
  }
  // $('body').on('click', '.gift-pro-content .gift-brand', function(e) {
  //   e.preventDefault();
  //   var productHandle = $(this).closest('.gift-product-item').attr('data-product-handle');
  //   $('.gift-more-product .gift-product-grid li').each(function(index, element) {
  //     if (productHandle == $(element).attr('data-product-handle')) {
  //       if ($(element).hasClass('active')) {
  //         $(element).removeClass('active');
  //       } else {
  //         $('.gift-more-product .gift-product-grid li').removeClass('active');
  //         $(element).addClass('active');
  //       }
  //     }
  //   });
  // });
  $('body').on('click', '.add-pro-gift', function(e) {
    e.preventDefault();
    var productHandle = $(this).closest('.gift-product-item').attr('data-product-handle');
    var variantID = parseInt($(this).closest('.gift-product-item').attr('data-variant'));
    var qty = 0;
    if ($(this).siblings('.add-pro-qty-wpr').length > 0) {
      $(this).siblings('.add-pro-qty-wpr').find('.qty-btn.plus-btn').click();
      $(this).hide();
      $(this).siblings('.add-pro-qty-wpr').show().addClass('active');
      qty = parseInt($(this).siblings('.add-pro-qty-wpr').find('input.pro-qty-input').val());
      addProduct(productHandle,qty,variantID);
    } else {
      $('.gift-more-product .gift-product-grid li').each(function(index, element) {
       if(productHandle == $(element).attr('data-product-handle') && $(element).find('.add-pro-qty-wpr').length == 0) {
         $(element).find('[data-target-modal]').click();
       }
      });
    }
  });
  $('body').on('click', '.gft-modal-btn button', function(e) {
    e.preventDefault();
    var productHandle = $(this).closest('.gft-modal-cont').attr('data-product-handle');
    var variantID = parseInt($(this).closest('.gft-modal-cont').attr('data-product-variant'));
    var qty = 0;
     $('.gift-more-product .gift-product-grid li').each(function(index, element) {
       if(productHandle == $(element).attr('data-product-handle')) {
        if(activeProducts.items.length > 0) {
          var checkProduct = false;
          activeProducts.items.forEach(function(product) {
            var existingProduct = activeProducts.items.find(item => item.variantId === variantID);
              if(existingProduct){
                checkProduct = true;
              }
            });
            if(checkProduct && variantID == parseInt($(element).attr('data-variant'))){
              if($(element).find('.add-pro-qty-wpr').length > 0 ) {
                $(element).find('.add-pro-qty-wpr').find('.qty-btn.plus-btn').click();
              } else {
                qty = existingProduct.quantity + 1;
                getCheckProduct(existingProduct,qty,variantID)
              }
            } else {
              if ($(element).find('.add-pro-qty-wpr').length > 0) {
                $(element).find('.add-pro-qty-wpr').find('.qty-btn.plus-btn').click();
                $(element).find('.add-pro-gift').hide();
                $(element).find('.add-pro-qty-wpr').show().addClass('active');
                qty = parseInt($(element).find('.add-pro-qty-wpr').find('input.pro-qty-input').val());
              } else {
                qty = 1;
                $(element).find('.add-pro-gift').show();
              }
              addProduct(productHandle,qty,variantID);
            }
        } else {
          if ($(element).find('.add-pro-qty-wpr').length > 0) {
            $(element).find('.add-pro-qty-wpr').find('.qty-btn.plus-btn').click();
            $(element).find('.add-pro-gift').hide();
            $(element).find('.add-pro-qty-wpr').show().addClass('active');
            qty = parseInt($(element).find('.add-pro-qty-wpr').find('input.pro-qty-input').val());
          } else {
            qty = 1;
            $(element).find('.add-pro-gift').show();
          }
          addProduct(productHandle,qty,variantID);
        }
        $('[data-gift-modal].show').remove();
        $('.gift-box-section').find('script[data-gift-box]').remove();
       }
    });
  })
  $('body').on('click', '[data-target-modal]', function(e) {
    e.preventDefault();
    var __this = $(this).parents('li');
    var currentHandle = __this.attr('data-product-handle');
    $('.gift-more-product .gift-product-grid li').each(function(index, element) {
      if(currentHandle == $(element).attr('data-product-handle')) {
        $.get('/products/'+ currentHandle +'?view=box-gift-modal', function(data) {
          $('.gift-box-section').append(data);
          $('[data-gift-modal]').addClass('show');
        });
       setTimeout(function() {
        if($('input:radio').is(':checked') ){
          var form = $('.product_form');
          variant_option(form);
        }
       },1000);
      }
    });
  });
  $('body').on('click', '.gift-li-remove .remove-items, .remove-items', function(e) {
    e.preventDefault();
    var variantId = parseInt($(this).closest('li').attr('data-id'));
    removeProduct(variantId);
  });
  function updateFlickitySlider(newImageSrc) {
    var $slider = $('.gft-modal-img-wpr');
    var $images = $slider.find('.gift-modal-img-items img');
    var indexToSelect = -1;
    $images.each(function (index) {
      if ($(this).attr('src') === newImageSrc) {
        indexToSelect = index;
        return false;
      }
    });
    if (indexToSelect !== -1) {
      flkty.select(indexToSelect);
    }
}
function variant_option(form) {
 var getVariantData = JSON.parse(form.find('[type="application/json"]').text());
 var option = [];
 if (form.find('input:checked').length == form.find('input:checked').length) {
  form.find('input:checked').each(function () {
    var value = $(this).val();
    option.push(value);
  });
   var currentVariant;
   $(getVariantData).each(function (index, value) {
    let count = 0;
    $(value.options).each(function (i, v) {
      if (option[i] != v) {
        count = 1; 
      }
    });
    if (count == 0) {
      currentVariant = value;
    }     
  });
  var currentvariant = currentVariant.id;
  var available = currentVariant.available;
   if (available) {
     form.find('.gft-modal-btn button').removeClass('disabled').removeAttr('disabled','disabled')
   }else {
     form.find('.gft-modal-btn button').addClass('disabled').attr('disabled','disabled')
   }
   var variantImage = currentVariant.featured_image;
    if (variantImage) {
      updateFlickitySlider(variantImage.src);
    }
     $('[data-gift-modal-cont]').attr('data-product-variant',currentvariant);
     var productHandle = $('[data-gift-modal-cont]').attr('data-product-handle');
     $('.gift-more-product .gift-product-grid li').each(function(index, element) {
       if(productHandle == $(element).attr('data-product-handle')){
         $(element).attr('data-variant',currentvariant);
       }
    });
  }
}  
  $('body').on('click','.variant-input input',function(){
    var form = $(this).parents('.product_form');
    variant_option(form);
  });
  $('body').on('click', '.add-pro-qty-wpr .qty-btn', function() {
    var input = $(this).siblings('input');
    var ip = parseInt(input.val());
    var variantId = parseInt(input.attr('data-id'));
    if($(this).hasClass('plus-btn')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      removeProduct(variantId);
      return
    }
    input.val(ip);
    $('.gift-more-product .gift-product-grid li').each(function(index, element) {
      if(variantId == parseInt($(element).attr('data-variant'))){
        if ($(element).find('.add-pro-qty-wpr').length > 0){
          $(element).find('.add-pro-qty-wpr').find('.total-count').text(`${ip} IN BOX`);
        } 
      }
    });
    var existingProduct = activeProducts.items.find(item => item.variantId === variantId);
    getCheckProduct(existingProduct,ip,variantId)
  });
  $('body').on("click",".add_box_btn",async function(e){
    e.preventDefault();
    var data ={
      items:[]
    };
    var mainProductTitles = [];
    var uniq_id = Math.round(Date.now() / 1000);
    var propertiesProducts = activeProducts.items.map(function(product) {
      mainProductTitles.push(`${product.title} x ${parseInt(product.quantity)}`);
    });
    var includesProperty = mainProductTitles.join(',');
    var mainProduct = {
      id: $('.pro-summary-middle .pro-info').attr('data-main-product'),
      quantity: 1,
      properties: {
        '_main_bundle': 'yes',
        '_bundle_id': uniq_id,
        'Includes':includesProperty
      }
    };
    data.items.push(mainProduct);
    var simplifiedProducts = activeProducts.items.map(function(product) {
      var productData = {
        id: product.variantId,
        quantity: parseInt(product.quantity),
        properties: {
          '_bundle_id': uniq_id,
          '_child_bundle': 'yes'
        }
      };
      data.items.push(productData);
    });
    var redirect = true;
    try {
      const response = await performServerAction(data);
      if (!response) return;
      if (redirect) {
       checkCartItemProperties();
      }
    } catch (error) {
      console.error(error);
    }    
  });
  $('body').on('click','.more-pro-load-btn a',function(e){
    e.preventDefault();
    var products_on_page = $(this).parents('.gift-more-product');
    var main_parent = $(this).parents('.gift-product-wpr');
    var next_url = products_on_page.find('.more-pro-load-btn a').attr('href');
    var load_more_btn = products_on_page.find('.more-pro-load-btn');
    var search_term = main_parent.find('#box-search').val().toLowerCase();
      $.ajax({
        url: next_url,
        type: 'GET',
        dataType: 'html',
        beforeSend: function(){
          load_more_btn.hide();
        }
      }).done(function(data){
      var new_products = $(data).find('.gift-product-grid'), new_url = $(data).find('.gift-more-product').find('.more-pro-load-btn a').attr('href');
      if(new_url)
      load_more_btn.show();
      next_url = new_url;
      products_on_page.find('.more-pro-load-btn a').attr('href',next_url);
      $('.gift-more-product .gift-product-grid').append(new_products.html());
      $('.gift-more-product .gift-product-grid li').each(function(index, element) {
        if (search_term.length > 0) {
          var p_title = $(element).attr('data-product-title').toLowerCase();
          if (p_title.indexOf(search_term) !== -1) {
              $(element).show();  // Show matching items
          } else {
              $(element).hide();  // Hide non-matching items
          }
        }else{
          $(element).show();
        }
      });
    })
  });
  function getd(currentURL) {
    $.get(currentURL, function(data) {   
      $('body').find('[data_collectionWPgrid]').html($(data).find('[data_collectionWPgrid]').html());
    });
  }
  function getUpdatedParams(currentParams, newParams) {
    const clone = new URLSearchParams(currentParams);
    const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];
    for (const [key, value] of clone.entries()) {
      if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
        clone.delete(key);
      };
    }
    for (const [key, value] of newParams.entries()) {
      if (Array.isArray(value)) {
        value.forEach(val => {
          if (!clone.getAll(key).includes(val) && val !== '') {
            clone.append(key, val);
          }
        });
      } else if (!clone.getAll(key).includes(value) && value !== '') {
        clone.append(key, value);
      }
    }
    return clone;
  }
  $('body').on('change', '.custom-filter .filter-opt-ul input[data-select-filter]', function(e) {     
    e.preventDefault();
    $('.custom-filter-wpr').removeClass('active');
    var formData = new FormData($('.filter-from')[0]);
    var searchParams = new URLSearchParams(formData);
    $('.custom-filter .filter-opt-ul input[data-select-filter]:checked').each(function() {
      var name = $(this).attr('name');
      var value = $(this).val();
      if (searchParams.has(name)) {
        searchParams.append(name,value);
      } else {
        searchParams.set(name,value);
      }
    });
    var currentParams = new URLSearchParams(window.location.search);
    var updatedParams = getUpdatedParams(currentParams, searchParams);
    var currentURL = `${window.location.pathname}?view=box-builder&${updatedParams.toString()}`;
    getd(currentURL); 
  });
  /* end filter */
  /* search */
  $('body').on('keyup change', '#box-search', function(e) {
    e.preventDefault();
    var term = $(this).val().toLowerCase();
    var hasVisibleProducts = false;
    $('.gift-product-grid li').each(function(index, element) {
      var p_title = $(element).attr('data-product-title').toLowerCase();
      if (term.length > 0) {
        if (p_title.indexOf(term) !== -1) {
          $(element).show();
          hasVisibleProducts = true;
        } else {
          $(element).hide();
        }
      } else {
        $(element).show();
        hasVisibleProducts = true;
        $('.gift-more-product').find('.more-pro-load-btn').show();
      }
    });
    if (!hasVisibleProducts) {
        $('.no-match-message').text('No Search Term "' + term + '" Found Product')
        $('.no-match-message').show();
        $('.gift-more-product').find('.more-pro-load-btn').hide();
    } else {
        $('.no-match-message').hide();
    }
  });
  $('.no-match-message').hide();
  $('body').on('click', '.gft-modal-close', function(e) {
    e.preventDefault();
    if ($('.greeting-card').length > 0 && $('.greeting-card').hasClass('show')) {
      $('.greeting-card').removeClass('show');
       setTimeout(function() {
        document.querySelector('.cart-link').click();
         jQuery.getJSON('/cart.js', function(cart) {
          let cartData = cart.items;
          document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true}));
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: cartData,
          })); 
         });
       }, 400);
    } else {
      $('[data-gift-modal].show').remove();
      $('.gift-box-section').find('script[data-gift-box]').remove();
    }
  })
  $(document).on('click','.custom-filter-wpr button', function() {
    if ($(this).parents('.custom-filter-wpr').hasClass('active')) {
      $('.custom-filter-wpr').removeClass('active')
    } else {
      $('.custom-filter-wpr').removeClass('active')
      $(this).parents('.custom-filter-wpr').addClass('active')
    }
  })
  $(document).mouseup(function (e) {  
    var giftModalBody = $(".gift-modal .gft-modal-body");  
    if (!giftModalBody.is(e.target) && giftModalBody.has(e.target).length === 0) { 
      if ($('.greeting-card').length > 0 && $('.greeting-card').hasClass('show')) {
      $('.greeting-card').removeClass('show');
      setTimeout(function() {
        document.querySelector('.cart-link').click();
         jQuery.getJSON('/cart.js', function(cart) {
          let cartData = cart.items;
          document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: cartData
          })); 
         });
       }, 400);
      } else {
        $('[data-gift-modal].show').remove();
        $('.gift-box-section').find('script[data-gift-box]').remove();
      }
    }  
    if (!$(".custom-filter-opt").is(e.target) && $(".custom-filter-opt").has(e.target).length === 0 && !$(".filter-by").is(e.target) && $(".filter-by").has(e.target).length === 0) {
      $('.custom-filter-wpr').removeClass('active')
    }
  });
  $('body').on('click', '.greeting-card #card-isle-cart', function(e) {
    e.preventDefault();
    if($(this).text() === 'Or add a complimentary gift message') {
      $(this).parents('.greeting-card').find('#TextCardTest').show();
      $(this).text('Hide complimentary message');
    }else if ($(this).text() === 'Hide complimentary message') {
      $(this).parents('.greeting-card').find('#TextCardTest').hide();
      $(this).text('Or add a complimentary gift message');
    }
    setTimeout(function () {
      greetingPopupScroll();
    }, 500);
  });
  $('body').on('keyup change', '.greeting-card #cartnotedrawer', function(e) {
    var parent = $(this).parents('.greeting-card');
    if($(this).val().length > 0){
      parent.find('.cart-note-button').show();
      setTimeout(function () {
        greetingPopupScroll();
      }, 500);
    }else{
      parent.find('.cart-note-button').hide();
      setTimeout(function () {
        greetingPopupScroll();
      }, 500);
    }
  });
  function greetingPopupScroll(){
    var scrollHeight = $('.gft-modal-pro-cont').outerHeight(); 
    $('.gft-modal-body-wpr').animate({
        scrollTop: scrollHeight
    }, 1000);
  }
  $('body').on('click', '.cart-note-button button', function(e) {
    var parent = $(this).parents('.greeting-card');
    var noteText = parent.find('#cartnotedrawer').val();
    theme.cart.updateNote(noteText);
    if (parent.length > 0 && parent.hasClass('show')) {
      parent.removeClass('show');
    }
    setTimeout(function() {
    document.querySelector('.cart-link').click();
     jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: cartData
      })); 
     });
   }, 400);
  });
});